module.exports = __webpack_public_path__ + "static/media/cheese-project.3e5d6d20.png";